var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0H5V1H9V0ZM0 9C0 12.866 3.134 16 7 16C10.866 16 14 12.866 14 9C14 5.134 10.866 2 7 2C3.134 2 0 5.134 0 9ZM7 3C10.314 3 13 5.686 13 9C13 12.314 10.314 15 7 15C3.686 15 1 12.314 1 9C1 5.686 3.686 3 7 3ZM11.9395 2.14706L12.6466 1.43996L14.0607 2.85416L13.3537 3.56126L11.9395 2.14706ZM7.42857 8.57143H9.57143C9.808 8.57143 10 8.76343 10 9C10 9.23657 9.808 9.42857 9.57143 9.42857H7.42857V11.5714C7.42857 11.808 7.23657 12 7 12C6.76343 12 6.57143 11.808 6.57143 11.5714V9.42857H4.42857C4.192 9.42857 4 9.23657 4 9C4 8.76343 4.192 8.57143 4.42857 8.57143H6.57143V6.42857C6.57143 6.192 6.76343 6 7 6C7.23657 6 7.42857 6.192 7.42857 6.42857V8.57143Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTime);
export default __webpack_public_path__ + "static/media/StopTime.b3e4e940.svg";
export { ForwardRef as ReactComponent };